<template>
  <div class="vrs-coordinates-map">
    <!-- Import Section -->
    <b-card class="mb-1">
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group label="استيراد ملف KMZ/KML">
            <b-input-group>
              <b-form-file
                v-model="kmzFile"
                accept=".kmz,.kml"
                placeholder="اختر ملف أو اسحب الملف هنا"
                drop-placeholder="اسحب الملف هنا"
                :disabled="importingKmz"
                @change="onKmzFileChange"
              />
              <b-input-group-append>
                <b-button
                  variant="success"
                  :disabled="!kmzFile || importingKmz"
                  @click="handleKmzImport"
                >
                  <feather-icon
                    icon="UploadIcon"
                    size="14"
                    class="mr-1"
                  />
                  {{ importingKmz ? 'جاري الاستيراد...' : 'استيراد' }}
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <small class="text-muted">يدعم الملفات: .kmz, .kml</small>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-alert
            v-if="kmzImportError"
            variant="danger"
            show
            class="mb-0"
          >
            {{ kmzImportError }}
          </b-alert>
          <b-alert
            v-if="kmzImportResult"
            variant="success"
            show
            class="mb-0"
          >
            <strong>تم الاستيراد بنجاح!</strong><br>
            اسم الملف: {{ kmzImportResult.file_name }}<br>
            عدد النقاط المحفوظة: {{ kmzImportResult.stored_points_count }}
          </b-alert>
        </b-col>
      </b-row>
    </b-card>

    <!-- Filters -->
    <!-- <b-card class="mb-1">
      <b-row>
        <b-col cols="12" md="3">
          <b-form-group label="Media ID">
            <b-form-input
              v-model.number="filters.media_id"
              type="number"
              placeholder="Media ID"
              @input="handleFilterChange"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="اسم الملف">
            <b-form-input
              v-model="filters.file_name"
              placeholder="اسم الملف"
              @input="handleFilterChange"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="اسم النقطة">
            <b-form-input
              v-model="filters.point_name"
              placeholder="اسم النقطة"
              @input="handleFilterChange"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="الإجراءات">
            <b-button variant="primary" @click="fetchPoints" :disabled="loading">
              <feather-icon icon="SearchIcon" size="14" class="mr-1"></feather-icon>
              بحث
            </b-button>
            <b-button variant="secondary" class="ml-2" @click="clearFilters">
              <feather-icon icon="XIcon" size="14" class="mr-1"></feather-icon>
              مسح
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card> -->

    <!-- Map Container -->
    <b-card>
      <div
        v-if="loading"
        class="text-center p-4"
      >
        <b-spinner />
        <p class="mt-2">
          جاري تحميل النقاط...
        </p>
      </div>
      <b-alert
        v-else-if="error"
        variant="danger"
        show
      >
        {{ error }}
      </b-alert>
      <div
        v-else-if="points.length === 0 && !loading"
        class="text-center p-4"
      >
        <p>لا توجد نقاط للعرض</p>
      </div>
      <div
        v-show="!loading && !error"
        ref="mapContainer"
        class="map-container"
        style="width: 100%; height: 600px;"
      />

      <!-- Points Info -->
      <div
        v-if="points.length > 0"
        class="mt-3"
      >
        <b-alert
          variant="info"
          show
        >
          <strong>عدد النقاط:</strong> {{ points.length }}
          <span v-if="pagination && pagination.total">
            (إجمالي: {{ pagination.total }})
          </span>
        </b-alert>
      </div>
    </b-card>
  </div>
</template>

<script>
import { loadArcgisModules } from '@/utils/arcgisLoader'
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormFile,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BAlert,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import geodesiaApi from '@/api/geodesia/geodesia'

export default {
  name: 'VrsCoordinatesMap',
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormFile,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BAlert,
    FeatherIcon,
  },
  props: {
    mediaId: {
      type: Number,
      default: null,
    },
    initialFilters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      map: null,
      view: null,
      graphicsLayer: null,
      arcgisModules: null,
      points: [],
      loading: false,
      error: null,
      pagination: null,
      kmzFile: null,
      importingKmz: false,
      kmzImportError: null,
      kmzImportResult: null,
      filters: {
        media_id: null,
        file_name: '',
        point_name: '',
        min_latitude: null,
        max_latitude: null,
        min_longitude: null,
        max_longitude: null,
        sort_by: 'id',
        sort_order: 'asc',
        per_page: 100,
        paginate: false,
        ...this.initialFilters,
      },
    }
  },
  watch: {
    mediaId(newVal) {
      if (newVal) {
        this.filters.media_id = newVal
        this.fetchPoints()
      }
    },
  },
  async mounted() {
    if (this.mediaId) {
      this.filters.media_id = this.mediaId
    }
    // Wait for next tick to ensure map container exists in DOM
    await this.$nextTick()
    // Initialize map first
    await this.initMap()
    // Then fetch points
    this.fetchPoints()
  },
  beforeDestroy() {
    if (this.view) {
      this.view.destroy()
      this.view = null
    }
  },
  methods: {
    async initMap() {
      try {
        const modules = await loadArcgisModules([
          'esri/Map',
          'esri/views/MapView',
          'esri/layers/GraphicsLayer',
          'esri/Graphic',
          'esri/geometry/Point',
          'esri/geometry/Extent',
          'esri/symbols/SimpleMarkerSymbol',
          'esri/symbols/TextSymbol',
          'esri/widgets/Search',
          'esri/widgets/Home',
          'esri/geometry/geometryEngine',
        ])

        this.arcgisModules = {
          Map: modules[0],
          MapView: modules[1],
          GraphicsLayer: modules[2],
          Graphic: modules[3],
          Point: modules[4],
          Extent: modules[5],
          SimpleMarkerSymbol: modules[6],
          TextSymbol: modules[7],
          Search: modules[8],
          Home: modules[9],
          geometryEngine: modules[10],
        }

        // Create map
        this.map = new this.arcgisModules.Map({
          basemap: 'hybrid',
        })

        // Create graphics layer
        this.graphicsLayer = new this.arcgisModules.GraphicsLayer()
        this.map.add(this.graphicsLayer)

        // Create view
        this.view = new this.arcgisModules.MapView({
          container: this.$refs.mapContainer,
          map: this.map,
          center: [31.2357, 30.0444], // Cairo, Egypt
          zoom: 10,
        })

        // Wait for view to be ready before adding widgets
        await this.view.when()

        // Add widgets
        const searchWidget = new this.arcgisModules.Search({
          view: this.view,
        })
        this.view.ui.add(searchWidget, {
          position: 'top-right',
        })

        const homeWidget = new this.arcgisModules.Home({
          view: this.view,
        })
        this.view.ui.add(homeWidget, {
          position: 'top-left',
        })

        // Watch for view extent changes to update bounding box filter
        this.view.watch('extent', () => {
          if (this.view && this.view.extent) {
            const { extent } = this.view
            this.filters.min_longitude = extent.xmin
            this.filters.max_longitude = extent.xmax
            this.filters.min_latitude = extent.ymin
            this.filters.max_latitude = extent.ymax
          }
        })
      } catch (err) {
        console.error('Error initializing map:', err)
        this.error = 'فشل تحميل الخريطة'
      }
    },
    async fetchPoints() {
      // Don't wait for map if it's not needed for the API call
      // Map will be initialized separately

      this.loading = true
      this.error = null

      try {
        const params = { ...this.filters }
        // Remove null and empty values
        Object.keys(params).forEach(key => {
          if (params[key] === null || params[key] === '') {
            delete params[key]
          }
        })

        // Convert paginate boolean to string
        if (params.paginate === false) {
          params.paginate = 'false'
        }

        const response = await geodesiaApi.getVrsCoordinatesMapPoints(params)

        // The request utility returns response.data, so check the structure accordingly
        if (response && (response.status === 'success' || response.success)) {
          // Handle both paginated and non-paginated responses
          if (response.data && response.data.points) {
            this.points = response.data.points
          } else if (response.data && Array.isArray(response.data)) {
            this.points = response.data
          } else if (Array.isArray(response)) {
            this.points = response
          } else {
            this.points = []
          }

          this.pagination = response.meta || null
          await this.renderPoints()
        } else {
          this.error = response?.message || 'فشل جلب النقاط'
        }
      } catch (err) {
        console.error('Error fetching VRS coordinates:', err)
        console.error('Error details:', {
          message: err.message,
          response: err.response,
          data: err.response?.data,
        })
        this.error = (err.response && err.response.data && err.response.data.message)
          || err.message
          || 'حدث خطأ أثناء جلب النقاط'
      } finally {
        this.loading = false
      }
    },
    async renderPoints() {
      if (!this.graphicsLayer || !this.arcgisModules || this.points.length === 0) {
        return
      }

      // Clear existing graphics
      this.graphicsLayer.removeAll()

      const {
        Graphic, Point, SimpleMarkerSymbol, TextSymbol,
      } = this.arcgisModules

      // Create marker symbol
      const markerSymbol = new SimpleMarkerSymbol({
        style: 'circle',
        color: [226, 119, 40, 0.8], // Orange color
        size: 8,
        outline: {
          color: [255, 255, 255, 0.8],
          width: 2,
        },
      })

      // Add points to map
      const graphics = []
      let bounds = null

      this.points.forEach(point => {
        const [longitude, latitude] = point.geometry.coordinates
        const geometry = new Point({
          longitude,
          latitude,
          spatialReference: { wkid: 4326 },
        })

        // Create popup content
        const { attributes } = point
        const popupContent = `
          <div style="padding: 10px;">
            <h4>${attributes.point_name || `Point ${attributes.id}`}</h4>
            <p><strong>ID:</strong> ${attributes.id}</p>
            <p><strong>Latitude:</strong> ${attributes.latitude.toFixed(8)}</p>
            <p><strong>Longitude:</strong> ${attributes.longitude.toFixed(8)}</p>
            ${attributes.elevation ? `<p><strong>Elevation:</strong> ${attributes.elevation}m</p>` : ''}
            ${attributes.file_name ? `<p><strong>File:</strong> ${attributes.file_name}</p>` : ''}
            ${attributes.point_description ? `<p><strong>Description:</strong> ${attributes.point_description}</p>` : ''}
            ${attributes.utm_east && attributes.utm_north ? `<p><strong>UTM:</strong> E: ${attributes.utm_east}, N: ${attributes.utm_north} (${attributes.utm_zone || ''})</p>` : ''}
            ${attributes.accuracy ? `<p><strong>Accuracy:</strong> ${attributes.accuracy}m</p>` : ''}
          </div>
        `

        const graphic = new Graphic({
          geometry,
          symbol: markerSymbol,
          attributes,
          popupTemplate: {
            title: attributes.point_name || `Point ${attributes.id}`,
            content: popupContent,
          },
        })

        graphics.push(graphic)

        // Update bounds
        if (!bounds) {
          bounds = {
            xmin: longitude,
            xmax: longitude,
            ymin: latitude,
            ymax: latitude,
          }
        } else {
          bounds.xmin = Math.min(bounds.xmin, longitude)
          bounds.xmax = Math.max(bounds.xmax, longitude)
          bounds.ymin = Math.min(bounds.ymin, latitude)
          bounds.ymax = Math.max(bounds.ymax, latitude)
        }
      })

      // Add graphics to layer
      this.graphicsLayer.addMany(graphics)

      // Fit map to bounds
      if (bounds && this.view && this.arcgisModules && this.arcgisModules.Extent) {
        try {
          // Ensure view is ready
          await this.view.when()

          // Create Extent object
          const extent = new this.arcgisModules.Extent({
            xmin: bounds.xmin,
            xmax: bounds.xmax,
            ymin: bounds.ymin,
            ymax: bounds.ymax,
            spatialReference: { wkid: 4326 },
          })

          // Go to extent with padding and disable animation to avoid errors
          await this.view.goTo(extent, {
            padding: 50,
            animate: false,
          })
        } catch (err) {
          console.warn('Error fitting view to bounds:', err)
          // Fallback: set extent directly
          try {
            if (this.view.extent) {
              const extent = new this.arcgisModules.Extent({
                xmin: bounds.xmin,
                xmax: bounds.xmax,
                ymin: bounds.ymin,
                ymax: bounds.ymax,
                spatialReference: { wkid: 4326 },
              })
              this.view.extent = extent
            }
          } catch (fallbackErr) {
            console.error('Error setting view extent:', fallbackErr)
          }
        }
      }
    },
    handleFilterChange() {
      // Debounce filter changes
      clearTimeout(this.filterTimeout)
      this.filterTimeout = setTimeout(() => {
        this.fetchPoints()
      }, 500)
    },
    clearFilters() {
      this.filters = {
        media_id: null,
        file_name: '',
        point_name: '',
        min_latitude: null,
        max_latitude: null,
        min_longitude: null,
        max_longitude: null,
        sort_by: 'id',
        sort_order: 'asc',
        per_page: 100,
        paginate: false,
      }
      this.fetchPoints()
    },
    onKmzFileChange(event) {
      const file = event.target.files ? event.target.files[0] : null
      if (file) {
        // Validate file extension
        const fileName = file.name.toLowerCase()
        if (!fileName.endsWith('.kmz') && !fileName.endsWith('.kml')) {
          this.kmzImportError = 'يجب أن يكون الملف من نوع .kmz أو .kml'
          this.kmzFile = null
          return
        }
        this.kmzImportError = null
        this.kmzImportResult = null
      }
    },
    async handleKmzImport() {
      if (!this.kmzFile) return

      this.importingKmz = true
      this.kmzImportError = null
      this.kmzImportResult = null

      try {
        const response = await geodesiaApi.importKmzFile(this.kmzFile)

        if (response.data && response.data.status === 'success') {
          this.kmzImportResult = response.data.data
          this.$toast.success(`تم استيراد ${response.data.data.stored_points_count} نقطة بنجاح`)

          // Auto-filter by the imported media_id and fetch points
          if (response.data.data.media_id) {
            this.filters.media_id = response.data.data.media_id
            // Wait a bit for the backend to process, then fetch points
            setTimeout(() => {
              this.fetchPoints()
            }, 1000)
          } else {
            // If no media_id, just refresh the points
            this.fetchPoints()
          }
        } else {
          this.kmzImportError = response?.message || 'فشل استيراد الملف'
        }
      } catch (err) {
        console.error('Error importing KMZ file:', err)

        if (err.response && err.response.data) {
          const errorData = err.response.data
          if (errorData.errors && errorData.errors.kmz_file) {
            this.kmzImportError = Array.isArray(errorData.errors.kmz_file)
              ? errorData.errors.kmz_file.join(', ')
              : errorData.errors.kmz_file
          } else {
            this.kmzImportError = errorData.message || 'فشل استيراد الملف'
          }
        } else {
          this.kmzImportError = 'حدث خطأ أثناء استيراد الملف'
        }
      } finally {
        this.importingKmz = false
      }
    },
  },
}
</script>

<style scoped>
.vrs-coordinates-map {
  width: 100%;
}

.map-container {
  border-radius: 8px;
  overflow: hidden;
}
</style>
